(function () {
  var OVERLAY_ID = 'looxOverlay_quickview';

  function clearScrollLock() {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.touchAction = '';
    document.documentElement.style.overflow = '';
  }

  function hasVisibleOverlay() {
    var overlay = document.getElementById(OVERLAY_ID);
    if (overlay && overlay.offsetWidth > 0) return true;
    var drawer = document.querySelector(
      '.menu-drawer-container[open], cart-drawer[open], dialog[open]'
    );
    if (drawer) return true;
    return false;
  }

  function isScrollLocked() {
    var bs = document.body.style;
    var hs = document.documentElement.style;
    if (bs.overflow === 'hidden' || hs.overflow === 'hidden') return true;
    if (bs.position === 'fixed') return true;
    if (bs.touchAction === 'none') return true;
    return false;
  }

  function guardScroll() {
    if (isScrollLocked() && !hasVisibleOverlay()) clearScrollLock();
  }

  function closeOverlay() {
    var overlay = document.getElementById(OVERLAY_ID);
    if (overlay) overlay.remove();
    clearScrollLock();
    if (typeof LOOX !== 'undefined' && LOOX.closeModal) {
      try { LOOX.closeModal(); } catch (e) {}
    }
  }

  function injectCloseButton(overlay) {
    if (overlay.querySelector('.loox-fix-close')) return;
    var btn = document.createElement('button');
    btn.className = 'loox-fix-close';
    btn.setAttribute('aria-label', 'Close');
    btn.textContent = '×';
    btn.style.cssText =
      'position:fixed;top:12px;right:12px;z-index:2147483647;' +
      'width:40px;height:40px;border-radius:50%;border:none;' +
      'background:rgba(0,0,0,0.6);color:#fff;font-size:24px;' +
      'line-height:1;cursor:pointer;display:flex;align-items:center;' +
      'justify-content:center;padding:0;-webkit-tap-highlight-color:transparent;';
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      closeOverlay();
    });
    overlay.appendChild(btn);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.id === OVERLAY_ID) {
          injectCloseButton(node);
        } else if (node.querySelector) {
          var nested = node.querySelector('#' + OVERLAY_ID);
          if (nested) injectCloseButton(nested);
        }
      }
      var removed = mutations[i].removedNodes;
      for (var k = 0; k < removed.length; k++) {
        var rn = removed[k];
        if (rn.nodeType === 1 && rn.id && String(rn.id).indexOf('loox') === 0) {
          setTimeout(clearScrollLock, 50);
        }
      }
    }
  });

  // Instant style guard: no delay, fires immediately on style/class changes
  var styleObserver = new MutationObserver(function () {
    guardScroll();
  });

  function init() {
    observer.observe(document.body, { childList: true, subtree: true });
    styleObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['style', 'class']
    });
    styleObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style', 'class']
    });

    // Clear scroll lock on any touch interaction (fires before scroll gets stuck)
    document.addEventListener('touchstart', guardScroll, { passive: true });
    document.addEventListener('touchmove', guardScroll, { passive: true });

    // Safety net interval as fallback
    setInterval(guardScroll, 1000);

    var existing = document.getElementById(OVERLAY_ID);
    if (existing) injectCloseButton(existing);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
